import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GatewayComponent } from './gateway/gateway.component';
import { ToolsRoutingModule } from './tools-routing.module';
import {
  NgbAccordionModule,
  NgbTooltipModule,
  NgbProgressbarModule,
} from '@ng-bootstrap/ng-bootstrap';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeatherModule } from 'angular-feather';
import { SerialEvenstCountPipe } from 'src/app/core/helpers/serialEventsCount-pipe';
import { TranslateMaxtrackComponent } from './translate-maxtrack/translate-maxtrack.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ErbsComponent } from './erbs/erbs.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ReportComponent } from './report/report.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { UtilsComponent } from './utils/utils.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { MapComponent } from './map/map.component';
import { CommandInfoComponent } from './command-info/command-info.component';
import { ProcessAutoComponent } from './process-auto/process-auto.component';
import { ProcessFlowComponent } from './process-flow/process-flow.component';

import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { SidebarModule } from 'primeng/sidebar';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    GatewayComponent,
    MonitoringComponent,
    SerialEvenstCountPipe,
    TranslateMaxtrackComponent,
    ErbsComponent,
    ReportComponent,
    UtilsComponent,
    MapComponent,
    CommandInfoComponent,
    ProcessAutoComponent,
    ProcessFlowComponent,
  ],
  imports: [
    CommonModule,
    ToolsRoutingModule,
    NgbAccordionModule,
    MatInputModule,
    FormsModule,
    FeatherModule,
    NgbTooltipModule,
    NgxJsonViewerModule,
    GoogleMapsModule,
    NgSelectModule,
    NgbNavModule,
    NgbProgressbarModule,
    TimelineModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    CardModule,
    DividerModule,
    ScrollPanelModule,
    AccordionModule,
    TabViewModule,
    SidebarModule,
    EditorModule,
    ButtonModule,
    UiSwitchModule.forRoot({
      size: 'small',
    }),
  ],
})
export class ToolsModule {}
